import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo, forwardRef } from "react";
const Text = memo(forwardRef(({
  as: Container = "span",
  children,
  className: classNameProp,
  componentClassName = ["view", "text"],
  fallback,
  values,
  translate,
  ...props
}, forwardedRef) => {
  const className = useClassName(componentClassName, classNameProp);
  if (translate) {
    if (typeof children === "string") {
      children = fallback ? translate(children, fallback, values) : translate(children, values);
    }
  }
  return /* @__PURE__ */ jsx(
    Container,
    {
      ref: forwardedRef,
      ...props,
      className,
      children
    }
  );
}));
Text.displayName = "Interface.Text";
export {
  Text
};
//# sourceMappingURL=Text.js.map
